// extracted by mini-css-extract-plugin
export const arrow = "InlineDropdownWrapper__arrow__PRJto";
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const caption = "InlineDropdownWrapper__caption__P-H3I";
export const dropdownContainer = "InlineDropdownWrapper__dropdownContainer__n9kWV";
export const dropdownContent = "InlineDropdownWrapper__dropdownContent__tgsoZ";
export const dropdownScrollable = "InlineDropdownWrapper__dropdownScrollable__+dWzV";
export const expanded = "InlineDropdownWrapper__expanded__EiLlx";
export const footerItem = "InlineDropdownWrapper__footerItem__naUiT";
export const group = "InlineDropdownWrapper__group__BeGYg";
export const groupHint = "InlineDropdownWrapper__groupHint__ajciM font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const groupList = "InlineDropdownWrapper__groupList__jHg-J";
export const groupName = "InlineDropdownWrapper__groupName__Wg3sW";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const inlineDropdown = "InlineDropdownWrapper__inlineDropdown__NXA35";
export const isMobile = "InlineDropdownWrapper__isMobile__mK8GN";
export const medium = "500";
export const note = "InlineDropdownWrapper__note__6jI8v";
export const onRight = "InlineDropdownWrapper__onRight__qsK4G";
export const option = "InlineDropdownWrapper__option__rScRC font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const optionCaption = "InlineDropdownWrapper__optionCaption__TGdTE";
export const outViewportDropdownOffset = "1rem";
export const regular = "400";
export const sans = "'sans'";
export const selectedOption = "InlineDropdownWrapper__selectedOption__UU32F";
export const semibold = "600";
export const serif = "'serif'";